
    export const BRANDING_COLOR = "#002b5c"
  